import { render } from "./BomHeaderItem.vue?vue&type=template&id=a65be89a&scoped=true"
import script from "./BomHeaderItem.vue?vue&type=script&lang=js"
export * from "./BomHeaderItem.vue?vue&type=script&lang=js"

import "./BomHeaderItem.vue?vue&type=style&index=0&id=a65be89a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65be89a"]])

export default __exports__